import { Alert } from '@ecargo/web-components';
import TitleBlock from './TitleBlock';
import StatusDetailBar from './StatusDetailBar';
import * as S from './styles/DetailHeader.style';
import { DetailHeaderProps } from './types';

/** Uses eCargo `Alert` for assignment errors — policy: `ECADCA-530-review.md` §2. */
export const DetailHeader = ({
    title,
    branchNumber,
    codes,
    route,
    etd,
    pieces,
    notificationStatus,
    caseStatus,
    onBack,
    hasUnsavedChanges,
    analyst,
    isAssigning,
    onAssign,
    assignmentErrorMessage,
    onClearAssignmentError,
}: DetailHeaderProps) => {   
    return (
        <S.Container>
            <TitleBlock title={title} branchNumber={branchNumber} onBack={onBack} hasUnsavedChanges={hasUnsavedChanges} />
            
            {assignmentErrorMessage && (
                <S.AlertWrapper>
                    <Alert
                        description={assignmentErrorMessage}
                        variant="error"
                        onClose={onClearAssignmentError}
                    />
                </S.AlertWrapper>
            )}
            
            <StatusDetailBar
                route={route}
                etd={etd}
                pieces={pieces}
                notificationStatus={notificationStatus}
                currentStatus={caseStatus}
                analyst={analyst}
                isAssigning={isAssigning}
                onAssign={onAssign}
            />
        </S.Container>
    );
};
